module.exports = __webpack_public_path__ + "static/media/ispy-3.75ad20ab.png";